export default "__VITE_ASSET__$LH3MntW__"